import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash, faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const Menu = () => {
    const navigate = useNavigate();
    const [value, setvalue] = useState("");
    const [menuData, setMenuData] = useState([]);
    const [deleteCode, setDeleteCode] = useState({})

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/menu`);
            setMenuData(result.data.dataContent);
        };
        fetchData();
    }, []);

    function deleteData(value) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/menu`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success == true) {
                    fetchData2()

                }
            })
            .catch(error => console.log('error', error));
    }

    async function fetchData2() {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/menu`);
        setMenuData(result.data.dataContent);
    }

    function viewData(value) {


        var x = document.createElement("a")
        x.id = "mpopupLink";
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "block";


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "UserCode": value.userCode
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users/getUsersExt`, requestOptions)
            .then(response => response.json())
            .then(result => {
                let userData = result.dataContent[0];

                document.getElementById("modal-content").innerHTML = '<h5 className="formgrouping">User Details</h5> <div className="row"> <div className="col-md-4"> <h6>User Name</h6> <p>' + userData.userName + '</p> </div> <div className="col-md-4"> <h6>Email Id</h6> <p>' + userData.emailId + '</p> </div> <div className="col-md-4"> <h6>Mobile No.</h6> <p>' + userData.mobile + '</p> </div> <div className="col-md-4"> <h6>Aadhar No.</h6> <p>' + userData.aadhar + '</p> </div> <div className="col-md-4"> <h6>Gender</h6> <p>' + userData.gender + '</p> </div> </div> <h5 className="formgrouping">User Credential</h5> <div className="row"> <div className="col-md-4"> <h6>User Id</h6> <p>' + userData.userId + '</p> </div> <div className="col-md-4"> <h6>Password</h6> <p>' + userData.password + '</p> </div> </div> <h5 className="formgrouping">Personal Details</h5> <div className="row"> <div className="col-md-4"> <h6>Designation Name</h6> <p>' + userData.desigName + '</p> </div> <div className="col-md-4"> <h6>Department Name</h6> <p>' + userData.deptName + '</p> </div> <div className="col-md-4"> <h6>Scheme</h6> <p>' + userData.schemeName + '</p> </div> <div className="col-md-4"> <h6>State Name</h6> <p>' + userData.stateName + '</p> </div> <div className="col-md-4"> <h6>District Name</h6> <p>' + userData.districtName + '</p> </div> <div className="col-md-4"> <h6>Sub District Name</h6> <p>' + userData.subDistrictName + '</p> </div> <div className="col-md-4"> <h6>Block Name</h6> <p>' + userData.blockName + '</p> </div> <div className="col-md-4"> <h6>Village Name</h6> <p>' + userData.villageName + '</p> </div> <div className="col-md-4"> <h6>Is Visible</h6> <p>' + userData.isVisible + '</p> </div> <div className="col-md-4"> <h6>Is Active</h6> <p>' + userData.isActive + '</p> </div> </div>';

            })
            .catch(error => console.log('error', error));


    }

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'schemeName',
                header: 'Scheme Name',
            },
            {
                 accessorKey: 'parentCode',
                header: 'Parent',
            },
            {
                accessorKey: 'menuTitle',
                header: 'Menu Title',
            },
            {
                accessorKey: 'formName',
                header: 'Attached Form',
            },
            {
                accessorKey: 'isActive',
                header: 'Is Active',
            },
            {
                accessor: '',
                header: 'Actions',
                Cell: cell => <>
                    <i className="btn text-primary" type="button" onClick={() => navigate("/usermanagement/addnewmenu", { state: { cropSurveyCode: cell.row.original } })}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_menu" onClick={() => setDeleteCode({ "MenuCode": cell.row.original.menuCode})} > <FontAwesomeIcon icon={faTrashAlt} /></i></>

            },
        ],
        [],
    );

    return (
        <>
            
            <main id="main" className="main">
                <div className="pagetitle">
                    <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                       
                        <nav>
                            <h1>Menu</h1>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">User Management</li>
                                <li className="breadcrumb-item active">Menu</li>
                            </ol>
                        </nav>
                        <button type="button" className="btn btn-success" onClick={() => navigate("/usermanagement/addnewmenu")}>Add New</button>
                    </div>
                
                </div>
                <section className="section">
                    {/*<div className="card dashboard">*/}
                    {/*    <div className="card-body">*/}
                            
                    {/*        <form className="g-3 addNewUser">*/}
                    {/*            <div className="row">*/}


                    {/*                <div className="col-md-4">*/}
                    {/*                    <label for="State" className="form-label">Role Name</label>*/}
                    {/*                    <input className="form-control" type="text" placeholder="Role Name" />*/}
                    {/*                </div>*/}
                    {/*                <div className="col-md-4">*/}
                    {/*                    <label for="District" className="form-label">Sorting Order</label>*/}
                    {/*                    <input className="form-control" type="number" placeholder="Sorting Order" />*/}
                    {/*                </div>*/}
                    {/*                <div className="col-md-4">*/}
                    {/*                    <label for="Block" className="form-label">Visibility</label>*/}
                    {/*                    <select id="Block" className="form-select">*/}
                    {/*                        <option selected>Choose...</option>*/}
                    {/*                        <option>Yes</option>*/}
                    {/*                        <option>No</option>*/}

                    {/*                    </select>*/}
                    {/*                </div>*/}



                    {/*                <div className="d-grid gap-2 d-md-flex justify-content-md-center">*/}
                    {/*                    <button className="btn btn-success me-md-2" type="button">Save</button>*/}
                    {/*                    <button className="btn btn-secondary" type="button">Reset</button>*/}
                    {/*                </div>*/}

                    {/*            </div>*/}
                    {/*        </form>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={menuData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                />
                            </div>

                        </div>

                        
                    </div>
                </section>

            </main>
         

            <div className="modal fade" id="staticBackdrop_menu" data-bs-backdrop="staticBackdrop_menu" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body">
                            <h6 id="deleteHeading">Are you sure you want to delete this item?</h6>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                            <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Menu;

